import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';
import { dashboard } from 'types';
import { filter } from 'es-toolkit/compat';

export default createSelector(
  (state: StoreType) => state.templateInfo.templateInfos,
  (templateInfos): dashboard.SeatingTemplateInfo[] => {
    return filter(
      templateInfos,
      (templateInfo) => !templateInfo._deleted
    ) as dashboard.SeatingTemplateInfo[];
  }
);
